import React from "react";
import { termsContent } from "./TermsContent";
import "./TermsModal.css"; 

const TermsModal = ({ onAccept, onCancel }) => {
  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal-container">
        <div className="terms-modal-content">
          <h2>Patient Terms of Use</h2>
          <p className="last-updated">
            <strong>Last Updated:</strong> July 25, 2018
          </p>

          <div className="terms-scrollable-content">
            {termsContent.map((section, index) => (
              <div key={index} className="terms-section">
                <h3>{section.title}</h3>
                <p>{section.content}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="terms-modal-footer">
          <div className="footer-hint">
            I warrant that my client, or my client's authorized substitute
            decision maker, has accepted the Nobel AI Legal Terms of Use and has
            consented to give access to his/her Personal Health Information
            gathered by Nobel AI Legal.
          </div>
          <div className="footer-buttons">
            <button className="cancel-btn" onClick={onCancel}>
              Cancel
            </button>
            <button className="accept-btn" onClick={onAccept}>
              Accept & Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TermsModal;
